module.exports = __webpack_public_path__ + "b20f1d63a47c85afddea266b4ea756c9.png";